import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { dateIsBetween } from '@/utils/timeUtils';

import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { ProductCard } from '@/components/ProductCard';
import { Typography } from '@/components/Typography';
import { getProductTranslatedName } from '@/lib/i18n';
import { getProductPdpPath } from '@/lib/product';
import { theme } from '@/theme';
import { messages as MyWatchMessages } from '@/views/MyWatchView/messages';

import type { Watch } from '../../MyWatchesView';

import * as M from '../../messages';
import * as S from './MyWatchCard.styles';
export interface MyWatchCardProps {
  watch: Watch;
}
export const MyWatchCard = ({ watch }: MyWatchCardProps) => {
  const { formatMessage } = useIntl();

  const endTime = watch.end_date && dayjs(watch.end_date).format('DD/MM/YYYY');
  const isEffective = dateIsBetween(watch.start_date, watch.end_date);
  return (
    <S.CardContainer key={watch?.sn} data-test-id='MyWatchCardCardContainer'>
      <ProductCard
        key={watch?.sn}
        backgroundColor={theme.colors.lightGrey}
        ctaType='bottom'
        data-test-id='MyWatchCardProductCardBox'
        href={getProductPdpPath(watch)}
        sku={watch.sku}
        type='watch'
      >
        <ProductCard.Zone>
          <ProductCard.Image
            alt={`${getProductTranslatedName(watch)} ${watch.sn}`}
            className='watch-soldier-image watch-card'
            data-test-id='MyWatchCardProductCardImage'
            productType='watch'
            sizes='50vw'
            src={watch?.thumbnail?.url || ''}
            withBackgroundPlaceholderBackground={false}
          />
        </ProductCard.Zone>
        <ProductCard.Zone>
          <ProductCard.Details data-test-id='MyWatchCardProductCardDetails'>
            <S.NameBox data-test-id='MyWatchCardNameBox'>
              <ProductCard.Name data-test-id='MyWatchCardProductName'>
                {watch?.name && getProductTranslatedName(watch)}
              </ProductCard.Name>
            </S.NameBox>
            <Typography data-test-id='MyWatchCardSerialNumber' scale='p2'>
              {M.SerialNumber} {watch?.sn}
            </Typography>
            <Typography data-test-id='MyWatchCardWarrantyStatus' scale='p2'>
              {M.WarrantyStatus}
            </Typography>
            {endTime && (
              <Flex alignItems='center' data-test-id='MyWatchCardValidIconFlex'>
                <S.ValidIcon
                  data-test-id='MyWatchCardValidIcon'
                  isValid={isEffective}
                />
                <Typography
                  color='secondaryGrey'
                  data-test-id='MyWatchCardValidUntil'
                  scale='p2'
                >
                  {formatMessage(MyWatchMessages.validUntil)} {endTime}
                </Typography>
              </Flex>
            )}

            <S.Button
              data-test-id='MyWatchCardSeeMoreDetailsButton'
              isProcessing={false}
              label={M.SeeMoreDetails}
              linkProps={{ href: getProductPdpPath(watch) || '#' }}
              variant='link'
            >
              <Icon name='chevronRight' />
            </S.Button>
          </ProductCard.Details>
        </ProductCard.Zone>
      </ProductCard>
    </S.CardContainer>
  );
};

MyWatchCard.displayName = 'MyWatchCard';
